<template>
  <div v-if="row.mappable">
    <SelectInput
      :model-value="row.fieldKey"
      :options="options"
      :disabled="disabled"
      placeholder="Don't import"
      filter
      inline
      :data-cy="`map-field-${row.index}`"
      @update:model-value="emit('pick', row, $event)"
    />
    <p
      v-if="help"
      class="mt-1 text-xs text-gray-500"
      :data-cy="`map-help-${row.index}`"
    >
      {{ help }}
    </p>
  </div>
  <span v-else class="text-sm text-gray-500"
    >Rename this column in the file to map it</span
  >
</template>

<script setup lang="ts">
import { computed } from "vue";

import SelectInput from "@/components/Seranova/SelectInput/SelectInput.vue";
import type { MapOption, MapRow } from "./mapColumns";

const props = defineProps<{
  row: MapRow;
  options: MapOption[];
  disabled: boolean;
}>();

const emit = defineEmits<{ pick: [row: MapRow, value: unknown] }>();

const help = computed(
  () =>
    props.options.find((option) => option.value === props.row.fieldKey)?.help
);
</script>
